import React from 'react'
import moment from 'moment'
import { Webinar } from '../../api/Types'

interface Props {
  readonly webinar: Webinar
  readonly isOpen?: boolean
  readonly isBot: boolean
}

const DocsWebinarCard: React.FunctionComponent<Props> = ({ webinar, isBot }) => {
  const { title_image, title, description, host, span, url_slug } = webinar
  return (
    <a href={`/webinars/${url_slug}`} className='docs-webinar-card-wrapper'>
      <div className='docs-webinar-card'>
        <div className='docs-webinar-card-image'>
          {!isBot && <img src={title_image.url} alt={title} />}
        </div>
        <div className='wrapper'>
          <h2 className='docs-webinar-card-header'>{title}</h2>
          <p className='docs-webinar-card-host'>with {host}</p>
          <p>{description}</p>
          <div className='docs-webinar-card-footer'>
            <span className='docs-webinar-card-footer-watch'>
              Watch Now
              <i className='fal fa-long-arrow-right i-right'></i>
            </span>
            <span>{moment.utc(span * 1000).format('mm:ss')} min</span>
          </div>
        </div>
      </div>
    </a>
  )
}

export default DocsWebinarCard
